import React, { useContext } from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import User from './User';
import { useAuth } from '@/context/AuthContext';
import { Menu } from 'lucide-react';
import { DocsScrollContext } from '../../contexts/DocsScrollContext';

const DashboardNav: React.FC = ({onMenuClick}) => {
  const location = useLocation();
  const { token } = useAuth();
  const docsScroll = useContext(DocsScrollContext);
  const currentDocPath = docsScroll?.currentDocPath ?? '';

  const getTitle = (pathname: string) => {
    const parts = pathname.split('/').filter(p => p);
    if (parts.length === 1) return parts[0];
    const raw = parts.length > 3 ? parts.slice(-2).join(' ') : parts[parts.length - 1];
    if(!raw){ return '' }
    return raw.replace(/-/g, ' ').replace(/\d+/g, '').replace(/\b\w/g, l => l.toUpperCase()).replace('Api', 'API').replace('Mcp', 'MCP Config');
  };

  const isDocsPage = location.pathname.startsWith('/docs');
  const title =
    isDocsPage && currentDocPath
      ? currentDocPath === 'index'
        ? 'Documentation'
        : getTitle(`/docs/${currentDocPath}`)
      : getTitle(location.pathname);

  return (
    <div className="flex items-start justify-between border-b border-gray-200 pb-5 px-4 md:px-8 mb-0 h-[49px]">

      <>
        <button className="lg:hidden cursor-pointer" onClick={onMenuClick}>
          <Menu />
        </button>
        <p className="text-xl font-semibold text-gray-900 capitalize">{title}</p>
      </>

      <div className="flex items-center gap-8">
        {token && (
          <div className="hidden md:flex gap-6">
            <NavLink
              to="/dashboard"
              className="relative flex items-center gap-2 group"
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`w-1 h-1 rounded-full bg-black absolute -bottom-1.5 left-[50%] transition-opacity duration-200 ${
                      isActive ? "opacity-100" : "opacity-0 group-hover:opacity-40"
                    }`}
                  />
                  <span
                    className={`transition-opacity duration-200 ${
                      isActive ? "opacity-100" : "opacity-100 group-hover:opacity-70"
                    }`}
                  >
                    Dashboard
                  </span>
                </>
              )}
            </NavLink>
            <NavLink
              to="/docs"
              className="relative flex items-center gap-2 group"
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`w-1 h-1 rounded-full bg-black absolute -bottom-1.5 left-[50%] transition-opacity duration-200 ${
                      isActive ? "opacity-100" : "opacity-0 group-hover:opacity-40"
                    }`}
                  />
                  <span
                    className={`transition-opacity duration-200 ${
                      isActive ? "opacity-100" : "opacity-100 group-hover:opacity-70"
                    }`}
                  >
                    Docs
                  </span>
                </>
              )}
            </NavLink>
          </div>
        )}
        {token ? <User /> : <Link to="/login" className="hover px-3 py-2 rounded-md transition-all duration-300 ease-in-out text-sm">Sign In</Link>}
      </div>
    </div>

  );
};

export default DashboardNav;
